module.exports = __webpack_public_path__ + "static/media/work-plan.538763a0.svg";